export default "__VITE_ASSET__CKm0Dr1a__"